import { useEffect, useState } from 'react';
import axios from 'axios';
import { CloseTransaction } from './CloseTransaction';
import Modal from '../Components/Modal';
import { RateModal } from './RateModal';
import { getToken } from '../utils';

function StageCloseTransaction({ content }) {
  const [confirmPayment, setConfirmPayment] = useState(false);
  const {
    getDataById,
    handleOpenandCloseModal,
    userToken,
    handleToast,
    openModal,
    bidUsers,
    disableCloseAccount,
    handleHideRating,
  } = content;
  const userId = getToken()?.user.id;
  const handleConfirmPayment = async () => {
    setConfirmPayment(true);
    try {
      let url;
      if (
        getDataById?.transaction_type?.name === 'Buy'
          ? getDataById?.originator?.id === userId
          : getDataById?.originator?.id !== userId
      ) {
        url = `${process.env.REACT_APP_BASE_URL}/payments/confirm-cx`;
      } else {
        url = `${process.env.REACT_APP_BASE_URL}/payments/confirm-ng`;
      }
      const response = await axios.post(
        url,
        {
          cx_id: getDataById.id,
        },
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        }
      );
      console.log(response.data, 'confirm Success');

      handleToast('success', `Payment confirmed!`);
      handleOpenandCloseModal('rateUser');
    } catch (error) {
      console.log(error, 'error in lv account');
      handleToast('error', 'Failed to complete request, please try again!');
    } finally {
      setConfirmPayment(false);
    }
  };

  //confirm payment
  // useEffect(() => {
  //   if (confirmPayment) {
  //     const confirmPayment = async () => {
  //       try {
  //         const response = await axios.post(
  //           'https://apex.loyaltyview.com/api/payments/confirm-cx',
  //           {
  //             cx_id: getDataById.id,
  //           },
  //           {
  //             headers: {
  //               Authorization: `Bearer ${userToken}`,
  //             },
  //           }
  //         );
  //         console.log(response.data, 'confirm Success');

  //         handleToast('success', `Payment confirmed!`);
  //         handleOpenandCloseModal('rateUser');
  //         setConfirmPayment(false);
  //       } catch (error) {
  //         console.log(error, 'error in lv account');
  //         handleToast('error', 'Failed to complete request, please try again!');
  //         setConfirmPayment(false);
  //       }
  //     };
  //     confirmPayment();
  //   }
  // }, [userToken, confirmPayment]);

  return (
    <div className='w-full pb-4 border-hf p-4 rounded-lg relative  bg-p-wh'>
      <div
        className={`${
          getDataById?.payment_status?.id === 8
            ? 'bg-b-mc text-p-wh'
            : getDataById?.payment_status?.id === 4 ||
              getDataById?.payment_status?.id === 2
            ? 'bg-orange-500 text-p-wh'
            : 'bg-p-wh'
        } w-fit h-fit px-4 py-2 absolute -top-6 left-1/2 transform -translate-x-1/2  drop-shadow-md rounded-full flex justify-center items-center`}
      >
        4
      </div>
      <div className='flex flex-row justify-between mt-2 mb-2'>
        <h2 className='font-semibold text-sm'>Close Transaction</h2>
        <button
          className='py-1.5 bg-b-mc text-p-wh h-fit rounded text-xs w-16 disabled:bg-p-bk/5 hover:bg-b-mc/75 focus:bg-b-mc/80'
          onClick={() => handleOpenandCloseModal('closeTransaction')}
          // disabled={
          //   (getDataById?.originator?.id === userId &&
          //     getDataById?.payment_status?.id !== 6) ||
          //   (getDataById?.originator?.id !== userId &&
          //     getDataById?.payment_status?.id !== 4)
          // }

          disabled={!disableCloseAccount}
        >
          Close
        </button>
      </div>
      <div className='text-xs flex flex-col text-p-bk'>
        <p className='pt-2'>
          Confirmed that you have recieve payment to close transaction
        </p>
      </div>
      <Modal open={openModal === 'closeTransaction'}>
        <CloseTransaction
          closeTransactionData={{
            viewData: getDataById,
            handleOpenandCloseModal,
            userToken,
            confirmPayment,
            setConfirmPayment,
            handleConfirmPayment,
          }}
        />
      </Modal>
      <Modal open={openModal === 'rateUser'}>
        <RateModal
          rateData={{
            userToken,
            viewData: getDataById,
            handleOpenandCloseModal,
            handleHideRating,
          }}
        />
      </Modal>
    </div>
  );
}

export default StageCloseTransaction;
